import { render, staticRenderFns } from "./JciProgramPaymentReport.vue?vue&type=template&id=60986cac&scoped=true"
import script from "./JciProgramPaymentReport.vue?vue&type=script&lang=js"
export * from "./JciProgramPaymentReport.vue?vue&type=script&lang=js"
import style0 from "./JciProgramPaymentReport.vue?vue&type=style&index=0&id=60986cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60986cac",
  null
  
)

export default component.exports